import Router, { RawLocation } from 'vue-router';

/** Names the page a route was opened from, so the user can be sent back to it. */
export const ORIGIN_QUERY_PARAM = 'from';

export class NavigationService {
  private router: Router;

  setRouter(router: any) {
    this.router = router;
  }

  navigate(route: RawLocation) {
    return this.router.push(route);
  }

  getCurrentPath() {
    return this.router.currentRoute.path;
  }

  /** True when the current route was opened from `routeName`, tagged with `?from=`. */
  isOpenedFrom(routeName: string) {
    return this.router.currentRoute.query[ORIGIN_QUERY_PARAM] === routeName;
  }
}

const navigationService = new NavigationService();
export default navigationService;
